module.exports = __webpack_public_path__ + "img/1.40eb1ccf.png";